import { useCallback } from 'react'

import { Ok } from 'ts-results'

import { useApplicationStore } from 'app/application/infrastructure'
import { useApi } from 'app/common/application'

import { ShopifyUpdateShopRequest, ShopifyUpdateShopResponse } from '../types'

const useShopifyConnectionApi = () => {
  const { create } = useApi()

  const updateConnectionData = useApplicationStore((state) => state.updateConnection)

  const updateShop = useCallback(
    async (shopName: string) => {
      const result = await create<ShopifyUpdateShopRequest, ShopifyUpdateShopResponse>(
        `/connections/shopify/updateShop`,
        { content: { shopName } },
      )
      if (result.ok) {
        const { _id: id, ...connEntity } = result.val.data
        updateConnectionData({ ...connEntity, id })

        return Ok(undefined)
      }

      return result
    },
    [create, updateConnectionData],
  )

  return {
    updateShop,
  }
}

export default useShopifyConnectionApi
